import { ApplicationConfig, importProvidersFrom, isDevMode, provideAppInitializer, provideCheckNoChangesConfig, provideZonelessChangeDetection } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxEchartsModule } from 'ngx-echarts';

import { APP_PROVIDERS } from '@app/app.providers';
import { loadEcharts } from '@common/echarts-loader';
import { unregisterLegacyServiceWorker } from '@common/sw-cleanup';
import { routes } from '@app/app.routes';

// Register Mexico locale data
registerLocaleData(localeEsMx);

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
    providers: [
        // Deteccion de cambios sin Zone.js (zone.js ya no se carga). La red de seguridad para los cambios
        // asincronos que no avisan a Angular esta en UiRefreshService (@common/ui-refresh.service)
        provideZonelessChangeDetection(),
        // Solo desarrollo: checkNoChanges exhaustivo periodico; reporta NG0100 donde un cambio de estado
        // no avisa a Angular (ayuda a detectar regresiones)
        ...(isDevMode() ? [provideCheckNoChangesConfig({ exhaustive: true, interval: 2000 })] : []),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        // Se retiro el Service Worker de Angular: limpiar el registro y las caches de versiones anteriores
        provideAppInitializer(() => unregisterLegacyServiceWorker()),
        importProvidersFrom(
            NgxEchartsModule.forRoot({
                echarts: loadEcharts,
            }),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: createTranslateLoader,
                    deps: [HttpClient],
                },
            }),
        ),
        ...APP_PROVIDERS,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ],
};
